<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "FieldsetOtherSpecs" });
import { Heading } from "../../../../../typography/index.js";
import { InputDate, Textarea } from "../../../../../inputs/index.js";
import { SelectGradeCodes } from "../../../../auction/index.js";
import SelectStockTypes from "../../select-stock-types/SelectStockTypes.svelte";
import SelectGenders from "../../select-genders/SelectGenders.svelte";
import SelectItemDepth from "../../select-item-depth/SelectItemDepth.svelte";
export let subscription;
const DOMAIN = import.meta.env.VITE_DOMAIN;
</script>

{#if subscription.constraints !== undefined}
    <div class = 'container'>
        <Heading size='xs'>{ `Do ${ DOMAIN === 'internal' ? 'they' : 'you' } have any other requirements?` }</Heading>

        <div class = 's8-row-of-3'>
            <SelectGradeCodes
                bind:keys = { subscription.constraints.gradeCodes }
                name = 'subscription.grade-codes'
                label = 'Stock Quality'
            />
            <SelectStockTypes
                bind:keys = { subscription.constraints.typeCodes }
                name = 'subscription.stock-types'
            />
            <SelectGenders
                bind:keys = { subscription.constraints.genderCodes }
                name = 'subscription.genders'
            />
        </div>

        <div class = 's8-row-of-2'>
            {#if subscription.constraints.minimum !== undefined}
                <SelectItemDepth
                    bind:key = { subscription.constraints.minimum.itemDepthCode }
                    name = 'subscription.item-depth'
                    placeholder = 'No. of Items per SKU'
                />
            {/if}
            <InputDate
                bind:value = { subscription.expiresAt }
                name = 'subscription.expiration-date'
                label = { `By when do ${ DOMAIN === 'internal' ? 'they' : 'you' } need this purchase latest?` }
                hint = { null }
                isRequired = { false }
            />
        </div>

        {#if DOMAIN === 'internal'}
            <Textarea
                bind:value = { subscription.comment }
                maxLength = { 1000 }
                isRequired = { false }
                placeholder = 'Section reserved for internal comments (not visible to buyers).'
                name = 'subscription.comment'
                label = 'Any other comments?'
            />
        {/if}
    </div>
{/if}

<style>
    div.container {
        margin-bottom: 15px;
    }

    div[class^='s8-row'] {
        display: grid;
        -moz-column-gap: 100px;
             column-gap: 100px;
    }

    div[class^='s8-row'].s8-row-of-2 {
            grid-template-columns: repeat(2, 1fr);
        }

    div[class^='s8-row'].s8-row-of-3 {
            grid-template-columns: repeat(3, 1fr);
        }

    @media (max-width: 780px) {
        div[class^='s8-row'] {
            display: flex;
            flex-direction: column;
        }
    }</style>